// extracted by mini-css-extract-plugin
export default {"TableContainer":"TableContainer_TableContainer__ncPnp"};